// 페이지 크기는 보고서 범위가 아니다. 현재 목록의 필터만 전달한다.
const SCOPE_KEYS = [
  "category", "index", "value",
  "treeBuildingName", "treeFloor", "treeLocation",
  "treeFacilityType", "treeFacilityName", "treePartName", "treeNodeId",
  "searchCategory", "searchKeyword",
  "fileType", "facilityType", "fusionResult",
];

export function getProjectReportListScope(searchParams) {
  return Object.fromEntries(
    SCOPE_KEYS.map((key) => [key, searchParams.get(key)])
      .filter(([, value]) => value !== null && value !== ""),
  );
}
